import type { ApiEmptyResponse, ApiError } from "@/services/api";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";

import { useInvalidateNotifications } from "./notifications.hook";

const markAllAsRead = () => {
  return client.user.notifications.markAllAsRead();
};

export const useMarkAllNotificationsAsRead = () => {
  const { invalidateNotifications } = useInvalidateNotifications();

  const onSuccess = () => {
    // Always return the invalidate queries promise to let mutation loader
    // displayed as long as notifications queries are refetching data
    return invalidateNotifications("*");
  };

  const { mutate, ...result } = useMutation<ApiEmptyResponse, ApiError>({
    mutationFn: markAllAsRead,
    onSuccess,
  });

  return {
    markAllAsRead: mutate,
    ...result,
  };
};
